namespace SPA {
	export namespace Realtor {

		import ClickEvent = JQuery.ClickEvent;
		import DateHelper = Helper.DateHelper;
		import ChangeEvent = JQuery.ChangeEvent;

		export interface ILeadsApiCredentials {
			url: string;
			accessToken: string;
		}

		export interface ILeadOffer {
			amount: number,
			period: number,
			volume: number,
			fixed_interest_effective: number,
		}

		enum LeadsState {
			Error = 'Error',
			NoGlobalOffer = 'NoGlobalOffer',
			NoGlobalExclusivOfferRequested = 'NoGlobalExclusivOfferRequested',
			GlobalOffer = 'GlobalOffer',
			ExclusivOfferRequested = 'ExclusivOfferRequested',
			ExclusivOfferResult = 'ExclusivOfferResult',
			ExclusivOfferAccepted = 'ExclusivOfferAccepted',
		}

		export class BauFinanzierungBuilder
			extends ObjectDataBuilder<RealtorObjectModel>
		{
			private m_Parent: JQuery | ui.base.BaseHTMLElement | null;
			private inputCreditAmount: JQuery;
			private selectPeriod: JQuery;
			// private inputPlz: JQuery;
			private selectAmount: JQuery;
			private selectRepayment: JQuery;
			private dataBody: JQuery;

			private leadsApiCredentials:ILeadsApiCredentials;

			private currentState:LeadsState = LeadsState.Error;

			bankOffers: ILeadOffer[] = [];

			periods = new Set<number>([10,20,30]);
			amounts = new Set<number>([60,70,80,90,100]);

			private objectPrice:number = 0;

			private bankImg:string = 'assets/images/Bank-Dummy-Logo.jpg';

			private objectNumber:string;
			private apiActionBtn: JQuery;
			private infoText: JQuery;
			private rebuildRoot: ui.base.BaseHTMLElement | JQuery<HTMLElement> | any;
			private btnRefreshData: JQuery;

			public refreshingData:boolean = false;

			public constructor(data: RealtorObjectModel) {
				super(data);

				// Setup Leads API Credentials
				let dataAccessToken:string;
				let dataUrl:string;
				$.ajax({
					url: 'conf/ajax.json?_=' + new Date().getTime(),
					method: 'GET',
					async: false,
					contentType: 'charset=utf-8',
					dataType: 'json',
					crossDomain: true,
					success: (jsonData) => {
						//console.log( "getLeadsAoiCredentials success" );
						dataAccessToken = jsonData.leadsApiCredentials.accessToken;
						dataUrl = jsonData.leadsApiCredentials.url;

					},
					error: () => {
						console.log( "getLeadsAoiCredentials error!" );
					}
				});

				this.leadsApiCredentials = new class implements ILeadsApiCredentials {
					accessToken: string = dataAccessToken;
					url: string = dataUrl;
				};

				// Set some Realtor Object parameter
				this.objectNumber = data.ObjectNumber;
				this.objectPrice = data.Data.general ? data.Data.general.price.value : 0;

				this.m_Parent = null;

				// Initialize the Request or Confirm Button
				this.apiActionBtn = $('<button class="btn btn-lg btn-block"><i class="fas"></i> <span class="btn_txt">Angebot anfragen</span></button>');

				// Initialize the Refresh Button
				this.btnRefreshData = $('<button class="btn btn-sm btn-default btn-refresh"><i class="fas fa-sync-alt"></i> <span class="hidden-xs">Daten neu laden</span></button>');

				this.infoText = $('<div class="row alert-container"><div class="info-text col-md-12"><div class="text-center alert"></div></div></div>');

				this.inputCreditAmount = $('<input class="form-control" style="text-align: right" disabled/>');

				// Initialize the Periods SelectBox
				this.selectPeriod = $(`<select class="form-control"></select>`);

				// Initialize the Amounts SelectBox
				this.selectAmount = $('<select class="form-control"></select>');

				// Initialize the Repayment SelectBox
				this.selectRepayment = $(`
					<select class="form-control">
						<option value="0.5">0,5 %</option>
						<option value="1">1,0 %</option>
						<option value="1.5" selected>1,5 %</option>
						<option value="2">2,0 %</option>
						<option value="2.5">2,5 %</option>
						<option value="3">3,0 %</option>
						<option value="3.5">3,5 %</option>
						<option value="4">4,0 %</option>
						<option value="4.5">4,5 %</option>
						<option value="5">5,0 %</option>
					</select>`);

				this.dataBody = ui.$$.div().addClass('baufi-body');
			}

			/**
			 * Get the Data from Leads API and Rebuild the View
			 * @param root
			 * @param navigation
			 */
			public rebuild(root: ui.base.BaseHTMLElement | JQuery<HTMLElement>, navigation?: Navigation): BauFinanzierungBuilder
			{
				this.rebuildRoot = root;

				this.currentState = LeadsState.Error;

				// Get Data from Lead API
				let jsonResult = {
					accepted: false,
					data: {
						mortgage: [],
						ends_at: '',
						accepted_at: '',
					},
					requested: false,
					success: false,
					type: '',
					created_at: {
						date: ''
					}
				};

				$.ajax({
					url: this.leadsApiCredentials.url + 'offers/' + btoa(this.objectNumber),
					method: 'GET',
					async: false,
					contentType: 'charset=utf-8',
					dataType: 'json',
					crossDomain: true,
					success: (jsonData) => {
						jsonResult = jsonData;
						//console.log( "get LeadsData success" );
					},
					error: () => {
						console.log( "getLeadsData error!" );
						this.infoText.find(".alert").html('Leider ist ein unerwarteter Fehler aufgetreten. Bitte versuchen sie es später nochmal.').addClass('alert-danger');
					}
				});

				// Setup State and Data
				if (jsonResult && jsonResult.data && jsonResult.data.mortgage && jsonResult.data.mortgage.length > 0) {

					// Reset Data
					this.bankOffers = [];
					this.periods = new Set<number>();
					this.amounts = new Set<number>();

					for (let offer of jsonResult.data.mortgage) {
						let typedOffer: ILeadOffer = offer;
						this.bankOffers.push(offer);

						// Setup Periods and Amounts
						this.periods.add(typedOffer.period);
						this.amounts.add(typedOffer.amount);
					}
				}

				// Setup Periods Select
				this.selectPeriod.empty();
				for (let period of Array.from( this.periods.values()).sort((a,b) => b - a)) {
					this.selectPeriod.append($('<option value="'+ period +'" selected>'+ period +' Jahre</option>'));
				}

				// Setup Amounts Select
				this.selectAmount.empty();
				for (let amount of Array.from( this.amounts.values()).sort((a,b) => b - a)) {
					this.selectAmount.append($('<option value="'+amount/100+'">'+amount+' %</option>'));
				}

				// Reset the Credit Amount
				this.inputCreditAmount.val(Math.round(this.objectPrice * parseFloat(String(this.selectAmount.val()))));

				// Set the current State
				if (jsonResult.success) {
					if (jsonResult.type === 'nA' && !jsonResult.requested && !jsonResult.accepted){
						this.currentState = LeadsState.NoGlobalOffer;
					}
					else if (jsonResult.type === 'nA' && jsonResult.requested && !jsonResult.accepted){
						this.currentState = LeadsState.NoGlobalExclusivOfferRequested;
					}
					else if (jsonResult.type === 'global' && !jsonResult.requested && !jsonResult.accepted){
						this.currentState = LeadsState.GlobalOffer;
					}
					else if (jsonResult.type === 'global' && jsonResult.requested && !jsonResult.accepted){
						this.currentState = LeadsState.ExclusivOfferRequested;
					}
					else if (jsonResult.type === 'exclusive' && jsonResult.requested && !jsonResult.accepted){
						this.currentState = LeadsState.ExclusivOfferResult;
					}
					else if (jsonResult.type === 'exclusive' && jsonResult.requested && jsonResult.accepted){
						this.currentState = LeadsState.ExclusivOfferAccepted;
					}
				}

				// Rest View Elements
				this.apiActionBtn
					.removeClass('disabled')
					.removeClass('btn-primary')
					.removeClass('btn-default')
					.removeClass('btn-success')
					.removeClass('hidden')
					.prop("disabled", false);
				this.apiActionBtn
					.find('.fas')
					.removeClass('fa-check-circle')
					.removeClass('fa-handshake');

				this.infoText.find(".alert")
					.removeClass('alert-info')
					.removeClass('alert-success');

				// There is NO Global offer
				if (this.currentState === LeadsState.NoGlobalOffer) {
					this.apiActionBtn.addClass("btn-primary").find('.btn_txt').html('Angebot anfragen');
					this.apiActionBtn.find('.fas').addClass('fa-check-circle');

					this.infoText.find(".alert").html('Leider liegt kein Beispiel-Finanzierungsangebot vor! Versuchen Sie es später nochmal.<br>Sie können aber trotzdem ein verbindliches Finanzierungsangebot anfragen.').addClass('alert-info');
				}
				// Requested an offer but there is NO Global offer
				else if (this.currentState === LeadsState.NoGlobalExclusivOfferRequested) {
					this.apiActionBtn.addClass("hidden");

					const dateTxt:string = DateHelper.getDateTimeFromTstamp(jsonResult.created_at.date, true);
					this.infoText.find(".alert").html('Ihre Finanzierungsanfrage ist am '+ dateTxt +' Uhr bei uns eingegangen und wird z.Z. bearbeitet').addClass('alert-info');
				}
				// Global offer
				else if (this.currentState === LeadsState.GlobalOffer) {
					this.apiActionBtn.addClass("btn-primary").find('.btn_txt').html('Angebot anfragen');
					this.apiActionBtn.find('.fas').addClass('fa-check-circle');

					this.infoText.find(".alert").html('Die z.Z. angezeigten Werte sind unverbindlich. <br>Sie können jedoch hier ein verbindliches Finanzierungsangebot anfragen. <br>Dieses wird nach kurzer Bearbeitungszeit hier angezeigt.').addClass('alert-info');
				}
				// Requested an offer
				else if (this.currentState === LeadsState.ExclusivOfferRequested) {
					this.apiActionBtn.addClass("btn-default").find('.btn_txt').html('Angebot angefragt');
					this.apiActionBtn.addClass('disabled').prop("disabled", true);
					this.apiActionBtn.find('.fas').addClass('fa-check-circle');

					const dateTxt:string = DateHelper.getDateTimeFromTstamp(jsonResult.created_at.date, true);
					this.infoText.find(".alert").html('Ihre Finanzierungsanfrage ist am '+ dateTxt +' Uhr bei uns eingegangen und wird z.Z. bearbeitet').addClass('alert-info');
				}
				// Exclusiv offer was set
				else if (this.currentState === LeadsState.ExclusivOfferResult) {
					this.apiActionBtn.addClass("btn-success").find('.btn_txt').html('Angebot bestätigen');
					this.apiActionBtn.find('.fas').addClass('fa-handshake');

					let infoTxt:string = "";
					if(jsonResult.data.ends_at){
						const dateCreatedTxt:string = DateHelper.getDateTimeFromTstamp(jsonResult.created_at.date, true);
						const dateEndsTxt:string = DateHelper.getDateTimeFromTstamp(jsonResult.data.ends_at);
						infoTxt = 'Ihre Anfrage ist am '+ dateCreatedTxt +' Uhr bei uns eingegangen. <br>Das vorliegende verbindliche Finanzierungsangebot ist bis '+ dateEndsTxt +' gültig.';
					} else{
						const dateCreatedTxt:string = DateHelper.getDateTimeFromTstamp(jsonResult.created_at.date, true);
						infoTxt = 'Ihre Anfrage ist am '+ dateCreatedTxt +' Uhr bei uns eingegangen. <br>Das vorliegende verbindliche Finanzierungsangebot hat kein Ablaufdatum ist aber in der Regel 1-2 Wochen gültig.';
					}

					this.infoText.find(".alert").html(infoTxt).addClass('alert-info');
				}
				// Exclusiv offer was accepted
				else if (this.currentState === LeadsState.ExclusivOfferAccepted) {
					this.apiActionBtn.addClass("btn-default").find('.btn_txt').html('Angebot bestätigt');
					this.apiActionBtn.addClass('disabled').prop("disabled", true);
					this.apiActionBtn.find('.fas').addClass('fa-check-circle');

					const dateCreatedTxt:string = DateHelper.getDateTimeFromTstamp(jsonResult.created_at.date, true);
					const dateAcceptedTxt:string = DateHelper.getDateTimeFromTstamp(jsonResult.data.accepted_at, true);
					this.infoText.find(".alert").html('Die Finanzierungsanfrage vom '+ dateCreatedTxt +' Uhr wurde am '+ dateAcceptedTxt +' Uhr von Ihnen bestätigt.').addClass('alert-success');
				}

				this.m_Parent = root;
				this.m_Parent.empty();

				const basicBox = new ui.Box.Box();

				basicBox.clearTitle();
				basicBox.rebuild(root);
				basicBox.append(ui.$$.h(2, [$('<span>Baufinanzierung</span>')]).addClass('segment'));

				basicBox.append($('<div class="refresh-outer text-right"></div>').append(this.btnRefreshData));


				if (this.currentState !== LeadsState.Error && this.currentState !== LeadsState.NoGlobalOffer && this.currentState !== LeadsState.NoGlobalExclusivOfferRequested){

					this.dataBody.empty();

					const html = $('<form class="container-fluid form-inline">')
						.wrap('<div class="navbar navbar-default">')
						.append(this.buildHeader())
						.append(`
							<div class="baufi-postheader">
								<div class="baufi-row row">
									<div class="anbieter col-md-2">&nbsp;</div>
									<div class="effzins  col-md-2">effektiver Jahreszins</div>
									<div class="restschuld  col-md-2">Restschuld</div>
									<div class="monatsrate  col-md-2">monatliche Rate</div>
									<div class="link col-md-4">&nbsp;</div>
								</div>
							</div>`
						)
						.append(this.dataBody);

					this.dataBody.append(`
						<div class="baufi-row row">
							<div class="anbieter col-md-2">
								<img src="${this.bankImg}" alt="" />
							</div>
							<div class="effzins val col-md-2"></div>
							<div class="restschuld val col-md-2"></div>
							<div class="monatsrate val col-md-2"></div>
							<div class="link col-md-4"></div>
						</div>`);

					this.dataBody.find(".link").append(this.apiActionBtn);

					this.refreshBodyContent();
					basicBox.append($(html));

				} else {
					// Add only the Request Offer Button
					const btnRow = ui.$$.div().addClass('row')
						.append(ui.$$.div().addClass('col-md-4'))
						.append(ui.$$.div().addClass('col-md-4 text-center')
						.append(this.apiActionBtn))
						.append(ui.$$.div().addClass('col-md-4'));
					basicBox.append(btnRow);
				}

				basicBox.append(this.infoText);

				// After the DOM is created, Setup all needed EventHandler
				this.setupAllEventHandler();

				return this;
			}

			/**
			 * 	Setup all needed EventHandler
			 */
			private setupAllEventHandler():void {

				// Set Handler for the Buttons
				this.apiActionBtn.on("click", (e) => this.onApiBtnClick(e));
				this.btnRefreshData.on("click", (e) => this.onRefreshBtnClick(e));

				// Set Handler for the SelectBoxes
				this.selectPeriod.on('change', () => this.refreshBodyContent());
				this.selectAmount.on('change', (e: ChangeEvent) => {
					this.inputCreditAmount.val(Math.round(this.objectPrice * parseFloat(e.target.value)));
					this.refreshBodyContent();
				});
				this.selectRepayment.on("change", () => this.refreshBodyContent());
			}

			/**
			 * Action on refresh Button click
			 * @param event
			 */
			private onRefreshBtnClick( event:ClickEvent):void
			{
				event.preventDefault();
				this.rebuild(this.rebuildRoot);
			}

			/**
			 * Action on Api Button click | Set new Lead or Confirm Offer
			 * @param event
			 */
			private onApiBtnClick( event:ClickEvent):void
			{
				event.preventDefault();

				// If there is no Offer Request
				if (this.currentState === LeadsState.NoGlobalOffer || this.currentState === LeadsState.GlobalOffer) {
					if(this.createNewLead()) {
						console.log( "set new LeadsData success" );
						this.showModalOnOfferRequest();
						this.rebuild(this.rebuildRoot);
					}
					else {
						console.log( "set new LeadsData error!" );
						this.infoText.find(".alert").html('Leider ist ein unerwarteter Fehler aufgetreten.<br>Bitte versuchen sie es später noch einmal oder überprüfen Sie, ob alle benötigten Objektdaten vorhanden sind.').addClass('alert-danger');
					}

				} // Accept the Offer
				else if(this.currentState == LeadsState.ExclusivOfferResult) {
					if( this.acceptOffer() ){
						console.log( "Offer accepted success" );
						this.showModalOnOfferAccepted();
						this.rebuild(this.rebuildRoot);
					}
					else {
						console.log( "acceptOffer:: API error!" );
						this.infoText.find(".alert").html('Leider ist ein unerwarteter Fehler aufgetreten.<br>Bitte versuchen sie es später noch einmal.').addClass('alert-danger');
					}
				}
			}

			/**
			 * Creates an new Lead in the Lead Api
			 */
			private createNewLead():boolean {

				let isLeadCreated:boolean = false;

				const genData = this.m_Data.Data.general;
				const objData = this.m_Data.attributes.Data;
				const advData = this.m_Data.attributes.AdvData;
				const addressData = this.m_Data.attributes.Address;

				// Convert modernization.object_condition to Lead API Condition
				let condition: string = 'GOOD';
				if(objData && objData.modernization && objData.modernization.object_condition) {
					switch (objData.modernization.object_condition) {
						case "VERY_GOOD":
							condition = "NEW";
							break;

						case "GOOD":
							condition = "AS_NEW";
							break;

						case "SATISFYING":
							condition = "GOOD";
							break;

						case "SUFFICIENT":
							condition = "NEED_SANATIZING";
							break;

						case "INADEQUAT":
							condition = "OLD";
							break;

						default: condition = "GOOD";
					}
				}

				const reqData = {
					"object": {
						"nhk": {
							"type":  objData? objData.common.type.type: "---",
							"basis": 2010
						},
						"areas": {
							"living": (objData && objData.details && objData.details.living_area && objData.details.living_area.value)? objData.details.living_area.value: 1,
							"outback": (objData && objData.property && objData.property.area && objData.property.area.garden )? objData.property.area.garden: 1,
							"buildable": (objData && objData.property && objData.property.area && objData.property.area.building)? objData.property.area.building: 1
						},
						"rooms": (advData && advData.rooms && advData.rooms != "")? advData.rooms: 1,
						"condition": condition,
						"construction_year": (objData && objData.details && objData.details.object && objData.details.object.construction_year)? objData.details.object.construction_year: 1700
					},
					"address": {
						"city": addressData? addressData.City: '--',
						"state": addressData? addressData.State: '--',
						"street": addressData? addressData.Street: '--',
						"suburb": null,
						"postalcode": addressData? addressData.PostalCode: '--',
						"geolocation": addressData? addressData.Geo: '--',
						"housenumber": addressData? addressData.HouseNumber: '--',
					},
					"proposition": {
						"value":  genData ? genData.price.value : 1,
					},
					'objectNumber' : this.objectNumber
				};

				$.ajax({
					url: this.leadsApiCredentials.url + 'leads/create',
					method: 'POST',
					async: false,
					contentType: 'application/json;charset=utf-8',
					dataType: 'json',
					crossDomain: true,
					processData: true,
					data: JSON.stringify(reqData),

					success: (successData) => {
						if(successData.success) {
							isLeadCreated = true;
						}
					},
					error: (errorData) => {
						console.log( "createNewLead:: API ERROR" );
						isLeadCreated = false;
					}
				});

				return isLeadCreated;
			}

			/**
			 * Accepts the Offer in the Lead Api
			 */
			private acceptOffer():boolean {

				let isOfferAccepted:boolean = false;

				// Confirm Offer
				$.ajax({
					url: this.leadsApiCredentials.url + 'offers/accept/' + btoa(this.objectNumber),
					method: 'GET',
					async: false,
					contentType: 'application/json;charset=utf-8',
					dataType: 'json',
					crossDomain: true,
					processData: true,

					success: (successData) => {
						if(successData.success) {
							isOfferAccepted = true;
						}
					},
					error: (errorData) => {
						isOfferAccepted = false;
					}

				});
				return isOfferAccepted;
			}

			/**
			 * Build the Header with all SelectBoxes
			 */
			private buildHeader(): JQuery {
				const header = $('<div class=" baufi-header">')
					.append(
						$('<div class="row"><div class="col-md-12"><h3>Objekt Angebotspreis: <span class="text-success">'+ Intl.NumberFormat('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.objectPrice)  +' € </span></h3></div><div class="col-md-12"><hr></div></div>')
					)
					.append(
						$('<div class="form-group">')
							.append('<label>Nettodarlehensbetrag</label>')
							.append($('<div class="input-group">')
								.append(this.inputCreditAmount)
								.append('<div class="input-group-addon">Euro</div>')
							)
					)
					.append(
						$('<div class="form-group">')
							.append('<label>Kreditlaufzeit</label>')
							.append(this.selectPeriod)
					)
					.append(
						$('<div class="form-group">')
							.append('<label>Beleihung</label>')
							.append(this.selectAmount)
					)
					.append(
						$('<div class="form-group">')
							.append('<label>Tilgung</label>')
							.append(this.selectRepayment)
					);

				return header;
			}

			/**
			 * Returns the Interest from the Offers by Selected Period and Amount
			 */
			private getInterestValue():number{

				let interest = 0;

				try {
					let selectedPeriod:number = Number(this.selectPeriod.val());
					let selectedAmount:number = Number(this.selectAmount.val());
					selectedAmount = selectedAmount*100;

					for (let offer of this.bankOffers) {
						if (offer.amount === selectedAmount && offer.period == selectedPeriod) {
							interest = offer.fixed_interest_effective;
						}
					}
				}
				catch (e) {

				}

				return interest;
			}

			/**
			 * Calculate and refresh the Offer price and percentage values
			 */
			private refreshBodyContent(): void
			{
				console.log("refreshBodyContent");

				const interest = this.getInterestValue();
				const calc = this.calculate(interest);

				this.dataBody.find(".effzins.val").html(Intl.NumberFormat('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(calc ? interest : 0) + " %");
				this.dataBody.find(".restschuld.val").html(Intl.NumberFormat('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(calc ? calc.restschuld : 0) + " €");
				this.dataBody.find(".monatsrate.val").html(Intl.NumberFormat('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(calc ? calc.rateMonat : 0) + " €");

			}

			/**
			 * calculate the interests and Monthly Rate from selected values
			 * @param zinssatz
			 */
			private calculate(zinssatz: number)
			{

				const tilgung = +Number(this.selectRepayment.val());
				const laufzeit = +Number(this.selectPeriod.val());

				const darlehen = +Number(this.inputCreditAmount.val());
				const gesamtzins = zinssatz + tilgung;
				const rateJahr = darlehen / 100 * gesamtzins;
				const rateGesamt = rateJahr * laufzeit;
				const rateMonat = rateJahr / 12;

				if (darlehen <= 0 || rateMonat <= 0 || tilgung <= 0 || zinssatz <= 0)
					return;

				const calc = this.doCalculation(darlehen, zinssatz, rateMonat, laufzeit);

				return calc;
			}

			private doCalculation(summe: number, zins: number, rate: number, jahre: number) {
				let zinsenMonat = 0;
				let tilgungMonat = 0;
				let zinsenGesamt = 0;
				let tilgungGesamt = 0;
				let zinsenJahr = 0;
				let tilgungJahr = 0;

				for (let i = 0; i < jahre; i++) {
					zinsenJahr = 0;
					tilgungJahr = 0;
					for (let j = 0; j < 12; j++) {
						zinsenMonat = summe * zins / 100 / 12;
						zinsenJahr += zinsenMonat;
						zinsenGesamt += zinsenMonat;
						tilgungMonat = rate - zinsenMonat;
						tilgungJahr += tilgungMonat;
						tilgungGesamt += tilgungMonat;
						summe = summe - tilgungMonat;
					}
				}
				return {
					rateMonat: rate,
					zinsen: zinsenGesamt,
					tilgung: tilgungGesamt,
					restschuld: summe
				};
			}

			/**
			 * ModalBox on successful Offer Request
			 */
			private showModalOnOfferRequest():void
			{
				const uiModal = new ui.dialog.Modal({
					size: 'lg',
					noCloseBtn: true,
					head: [$('<h3>Anfrage Baufinanzierung</h3>')],
					body: [
						$(`<div style='font-size:16px'><h3>Vielen Dank für Ihre Finanzierungsanfrage</h3>
<p>Ihre Baufinanzierunganfrage ist bei uns eingegangen und wird schnellst möglich bearbeitet.
<br><br></p></div>`)
					],
					foot: [
						$('<button class="btn btn-primary" data-dismiss="modal">Schließen</button>')
					]
				});
				uiModal.Show();
			}

			/**
			 * ModalBox on successful Offer Accepted
			 */
			private showModalOnOfferAccepted():void
			{
				const uiModal = new ui.dialog.Modal({
					size: 'lg',
					noCloseBtn: true,
					head: [$('<h3>Baufinanzierung bestätigt</h3>')],
					body: [
						$(`<div style='font-size:16px'><h3>Vielen Dank für Ihre Finanzierungsbestätigung</h3>
<p>Für die Vertragsunterlagen setzen wir uns schnellst möglich mit Ihnen in Verbindung.
<br><br></p></div>`)
					],
					foot: [
						$('<button class="btn btn-primary" data-dismiss="modal">Schließen</button>')
					]
				});
				uiModal.Show();
			}
		}
	}
}
